/* tslint:disable */
/* eslint-disable */
/**
 * Property Search API
 * Search properties and get aggregated info about areas.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyTypeOptionDto
 */
export interface PropertyTypeOptionDto {
    /**
     * 
     * @type {string}
     * @memberof PropertyTypeOptionDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyTypeOptionDto
     */
    nameId: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyTypeOptionDto
     */
    mlsSource?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PropertyTypeOptionDto
     */
    canonical: boolean;
}

/**
 * Check if a given object implements the PropertyTypeOptionDto interface.
 */
export function instanceOfPropertyTypeOptionDto(value: object): value is PropertyTypeOptionDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('nameId' in value) || value['nameId'] === undefined) return false;
    if (!('canonical' in value) || value['canonical'] === undefined) return false;
    return true;
}

export function PropertyTypeOptionDtoFromJSON(json: any): PropertyTypeOptionDto {
    return PropertyTypeOptionDtoFromJSONTyped(json, false);
}

export function PropertyTypeOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyTypeOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'nameId': json['nameId'],
        'mlsSource': json['mlsSource'] == null ? undefined : json['mlsSource'],
        'canonical': json['canonical'],
    };
}

export function PropertyTypeOptionDtoToJSON(json: any): PropertyTypeOptionDto {
    return PropertyTypeOptionDtoToJSONTyped(json, false);
}

export function PropertyTypeOptionDtoToJSONTyped(value?: PropertyTypeOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'nameId': value['nameId'],
        'mlsSource': value['mlsSource'],
        'canonical': value['canonical'],
    };
}

